import type { BffClientOptions } from './types';

type ClientWithRequestInterceptors = {
  interceptors: {
    request: {
      use: (
        handler: (request: Request) => Request | Promise<Request>,
      ) => unknown;
    };
  };
};

type CreateClient<TClient extends ClientWithRequestInterceptors> = (options: {
  baseUrl: string;
  fetch?: typeof fetch;
  auth?: string | (() => string | Promise<string>);
}) => TClient;

export function createConfiguredClient<
  TClient extends ClientWithRequestInterceptors,
>(createClient: CreateClient<TClient>, options: BffClientOptions): TClient {
  const client = createClient({
    baseUrl: options.baseUrl,
    fetch: options.fetch,
    auth: options.auth,
  });

  if (options.headers) {
    client.interceptors.request.use(async (request) => {
      const resolvedHeaders =
        typeof options.headers === 'function'
          ? await options.headers()
          : options.headers;

      const headers = new Headers(request.headers);
      new Headers(resolvedHeaders).forEach((value, key) => {
        headers.set(key, value);
      });

      return new Request(request, { headers });
    });
  }

  return client;
}
